import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ComingSoonPage.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';
const PREVIEW_CODE = 'preview';

export default function ComingSoonPage({
  preview = false,
  onUnlock,
}) {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const next = code.trim();
    if (!next) {
      setError('Enter an access code.');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      if (preview) {
        if (next.toLowerCase() !== PREVIEW_CODE) {
          throw new Error('Use the preview code: preview');
        }
        onUnlock?.();
        navigate('/', { replace: true });
        return;
      }

      await onUnlock?.(next);
    } catch (err) {
      setError(err?.message || 'That code did not work.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="comingSoon">
      <div className="comingSoon__glow comingSoon__glow--left" aria-hidden="true" />
      <div className="comingSoon__glow comingSoon__glow--right" aria-hidden="true" />

      <main className="comingSoon__stage">
        {preview ? (
          <p className="comingSoon__previewFlag">Preview only — the live site is unchanged until you enable this in App Settings</p>
        ) : null}

        <img
          className="comingSoon__logo"
          src={`${PUBLIC_URL}/neatschedule.png`}
          alt="Neat Schedule"
        />

        <p className="comingSoon__eyebrow">A new scheduling experience</p>
        <h1 className="comingSoon__title">Coming soon</h1>
        <p className="comingSoon__lede">
          We are putting the finishing touches on Neat Schedule. Leave your day-to-day
          bookings with us. We will be ready shortly.
        </p>

        <form className="comingSoon__card" onSubmit={handleSubmit}>
          <label className="comingSoon__label" htmlFor="coming-soon-code">
            Have an access code?
          </label>
          <div className="comingSoon__row">
            <input
              id="coming-soon-code"
              className="comingSoon__input"
              type="password"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setError('');
              }}
              placeholder={preview ? 'preview' : 'Access code'}
              autoComplete="off"
              spellCheck="false"
            />
            <button className="comingSoon__button" type="submit" disabled={submitting}>
              {submitting ? 'Checking…' : 'Enter'}
            </button>
          </div>
          {error ? (
            <p className="comingSoon__error" role="alert">
              {error}
            </p>
          ) : (
            <p className="comingSoon__hint">
              {preview
                ? 'Type preview and press Enter to see the real site behind this page.'
                : 'Private access for teammates and early testers.'}
            </p>
          )}
        </form>
      </main>
    </div>
  );
}
